// ─── src/hooks/useNewsletter.ts ───────────────────────────────────────────────

import { useMutation, useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { deleteNewsletterSubscriber, getNewsletterSubscribers } from "../api/newsletter";
import type { NewsletterParams } from "../types/newsletter";

export const newsletterKeys = {
  all:  ["newsletter"] as const,
  list: (params: NewsletterParams) => [...newsletterKeys.all, "list", params] as const,
};

export const useNewsletter = (params: NewsletterParams) =>
  useQuery({
    queryKey:        newsletterKeys.list(params),
    queryFn:         () => getNewsletterSubscribers(params),
    placeholderData: keepPreviousData,
    staleTime:       30_000,
  });

export const useDeleteSubscriber = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteNewsletterSubscriber(id),
    onSuccess:  () => qc.invalidateQueries({ queryKey: newsletterKeys.all }),
  });
};
